import { createAcpManagerContext } from './acp-manager-context.js';
import { cancelRun } from './cancel-run.js';
import { disconnectAll } from './disconnect-all.js';
import { handlePrompt } from './handle-prompt.js';
import { logPromptReceivedFromBridge } from './log-prompt-received.js';
import type { AcpManager, AcpManagerOptions } from './types.js';

/**
 * One ACP subprocess per cloud session + agent identity; prompt turns register session/run routing
 * while they stream so callbacks reach the correct turn.
 */
export async function createAcpManager(options: AcpManagerOptions): Promise<AcpManager> {
  const ctx = createAcpManagerContext({
    log: options.log,
    getBridgeAccessPort: options.getBridgeAccessPort,
    reportAgentCapabilities: options.reportAgentCapabilities,
  });

  return {
    setPreferredAgentType(agentType: string) {
      if (!ctx.backendFallbackAgentType) {
        ctx.backendFallbackAgentType = agentType;
      }
    },
    logPromptReceivedFromBridge: (opts) => logPromptReceivedFromBridge(ctx, opts),
    handlePrompt: (opts) => handlePrompt(ctx, opts),
    cancelRun: (runId) => cancelRun(ctx, runId),
    resolveRequest(requestId: string, result: unknown) {
      for (const state of ctx.acpAgents.values()) {
        state.acpHandle?.resolveRequest?.(requestId, result);
      }
    },
    disconnect: () => disconnectAll(ctx),
  };
}
